module.exports = __webpack_public_path__ + "static/media/pivot.36c40913.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/GetAShareResources/pivot.svg
// module id = 179
// module chunks = 0